import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withProps, withState } from 'recompose';
import * as R from 'ramda';
import { t } from 'i18next';
import { push } from 'connected-react-router';

import {
  fetchCompaniesByAdmin,
  clearCompanies
} from '../../../../modules/company/companyActions';

import { ITEMS_PER_PAGE } from '../../../constants/pagination';
import { TableTitleNameS } from '../../common/table/TableS';
import { STATUSES_STATE, VerifySelect } from './companyStatusesComponent'

const normalizeCompanyList = companies => companies.map(company => {
  const name = R.pathOr('-', ['name'], company);
  return {
    name: <TableTitleNameS title={name}>{ name }</TableTitleNameS>,
    verified: <VerifySelect company={company}/>
  }
});

const CompanyStatusesContainer = compose(
  connect(({ company, router }) => ({
    companies: normalizeCompanyList(company.list),
    amount: company.amount,
    location: router.location
  }), { fetchCompaniesByAdmin, clearCompanies, push }),
  withState('page', 'setPage', 1),
  withState('itemsPerPage', 'setItemsPerPage', ITEMS_PER_PAGE[10]),
  withState('statusesStateType', 'setStatusesStateType', STATUSES_STATE.ALL),
  withState('sort', 'setSort', { name: 0 }),
  withProps(({ sort, setSort }) => ({
    statusesColumns: [
      {
        title: t('adminPanel.statuses.tableHeaders.name'),
        sort: {
          sortFunc : (sortOrder) => setSort({ name: sortOrder }),
          sortState: sort.name
        }
      },
      {
        title: t('adminPanel.statuses.tableHeaders.verification'),
      }
    ]
  })),
  lifecycle({
    componentDidMount() {
      const { fetchCompaniesByAdmin, page, itemsPerPage } = this.props;
      fetchCompaniesByAdmin(page, itemsPerPage);
    },

    componentDidUpdate(prevProps) {
      const { page, setPage, itemsPerPage, sort, fetchCompaniesByAdmin, statusesStateType, clearCompanies } = this.props;

      const isPropNotEqual = i => !R.equals(R.prop(i, this.props), R.prop(i, prevProps));
      if (['statusesStateType'].find(isPropNotEqual)) {
        setPage(1);
        clearCompanies();
      }

      if (['itemsPerPage', 'page', 'sort', 'statusesStateType'].find(isPropNotEqual)) {
        const verified = STATUSES_STATE.ALL === statusesStateType ? null : statusesStateType;
        const getSortValue = (s) => R.pickBy((val) => val !== 0, s);

        fetchCompaniesByAdmin(page - 1, itemsPerPage, getSortValue(sort), null, verified)
      }
    }
  })
);

export default CompanyStatusesContainer;
